import InputAdornment from '@material-ui/core/InputAdornment';
import { Draggable } from 'react-beautiful-dnd';

import TextField from '~/components/TextField';
import DragHandleImage from '~/images/forms/fields/drag.svg';
import Remove from '~/images/forms/fields/remove.svg';

const DragHandle = ({ classes, dragHandleProps }) => (
  <InputAdornment position="start" className={classes.grabHandleAdornment}>
    <div {...dragHandleProps}>
      <DragHandleImage className={classes.dragHandle} />
    </div>
  </InputAdornment>
);

DragHandle.propTypes = {
  classes: PropTypes.shape({
    dragHandle: PropTypes.string.isRequired,
    grabHandleAdornment: PropTypes.string.isRequired,
  }).isRequired,
  dragHandleProps: PropTypes.object.isRequired,
};

const SelectOption = ({ option, index, error, classes, ...handlers }) => (
  <Draggable draggableId={`option-${index}`} index={index}>
    {(provided) => (
      <div
        className={classes.option}
        style={provided.draggableProps.style}
        ref={provided.innerRef}>
        <TextField
          variant="standard"
          id={`option-${index}`}
          fullWidth
          error={error}
          InputProps={{
            startAdornment: (
              <DragHandle
                dragHandleProps={provided.dragHandleProps}
                classes={classes}
              />
            ),
          }}
          value={option}
          onChange={handlers.handleChange}
          onKeyDown={handlers.handleKeyPress}
          onBlur={handlers.onBlur}
        />

        <div
          className={classnames([classes.remove, 'remove'])}
          onClick={handlers.onDelete}>
          <Remove />
        </div>
      </div>
    )}
  </Draggable>
);

SelectOption.propTypes = {
  classes: PropTypes.shape({
    option: PropTypes.string.isRequired,
    remove: PropTypes.string.isRequired,
  }).isRequired,
  option: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
};

export default SelectOption;
